const arrayUnique = (array) => array.filter((value, index, self) => self.indexOf(value) === index);

export default arrayUnique;
